import Model from '../Model'

export default class RequestForMaterials extends Model {
    setAttributes(attributes) {
        super.setAttributes(attributes)
        let tokens = [
            attributes.requestedFor,
            attributes.packageReference,
            attributes.packageName,
            attributes.reference,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static parseAttributes(attributes = {}) {
        attributes.package = attributes.package?.value
        return attributes
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.procurement.request-for-materials', {
            package_reference: packageReference,
            id
        }), {})
        return this.make(data)
    }

    static cache = new Map()

    static async all(packageReference = null) {
        let o = RequestForMaterials.cache.get(packageReference ? packageReference : '-1');
        if (!o || (o.expires < new Date().getTime())) {
            o = {
                data: Http.get(route('api.v2.procurement.request-for-materials.list', [packageReference])),
                expires: new Date().getTime() + 2000,
            };
            RequestForMaterials.cache.set(packageReference ? packageReference : '-1', o);
        }
        return this.make(await o.data);
    }

    async updateResolves(attributes = {}) {
        const url = route('api.v2.procurement.request-for-materials.resolves.store', {
            package_reference: this.packageReference,
            id: this.id
        })
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const o = await Http.put(url, payload)
    }

    async updateDeliveryDates(attributes = {}) {
        const url = route('api.v2.procurement.request-for-materials.delivery-dates.store', {
            package_reference: this.packageReference,
            id: this.id
        })
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const o = await Http.put(url, payload)
    }

    async complete() {
        await Http.post(route('api.v2.procurement.request-for-materials.complete', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async acknowledge() {
        await Http.post(route('api.v2.procurement.request-for-materials.acknowledge', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async refresh() {
        const data = await RequestForMaterials.find(this.packageReference, this.id)
        Object.assign(this, data)
    }

    async saveAndRefresh() {
        await this.update()
        await this.refresh()
    }

}
